<template>
  <div id="kpi1">
    <div class="box">
      <div id="chartKpi1" style="height:100%"></div>
    </div>
  </div>
</template>

<script>
// 2：导入echarts
import echarts from 'echarts';

export default {
  name: 'kpi1',
  data() {
    return {
      // 需要合并对象，样式
      legendColor: false,
      mm: 5,
      dataset: [],
      dataLabel: [],
      equipDesc: [],
      shadowBar: []
    };
  },
  created() {},
  mounted() {
  },
  methods: {
    refreshChart(chartData, queryArgs) {
       const serColors = ['#1E90FF', '#008B45', '#99d0b9', '#8E8E38', '#6aa36a'];
     console.log("B1",chartData);
      var that = this;
      const data1 = [];
      const data2 = [];
      const data3 = [];
      const titleData = [];
      const equipDesc = [];
      this.dataset = [];
      this.shadowBar = [];
     console.log("items",chartData[0]);
        for (var i = 0; i < chartData.length; i++) {
          data1.push(chartData[i].Key);
          console.log("itemKey",chartData[i].Key);
          data2.push(chartData[i].KpiArr);
        }
      console.log(data1);
      console.log(data2);
      this.dataset=[data1,data2];

      var myChart = echarts.init(document.getElementById('chartKpi1'));
      myChart.clear()

      var zoomConfig = []
      var iZoomLength = 8
      if (data1.length > iZoomLength) {
        zoomConfig.push({
          type: 'slider',
          show : true,
          realtime : true,
          start: 0,
          end: iZoomLength / data1.length * 100
          },{
          type: 'inside',
          show : true,
          realtime : true,
          start: 0,
          end: iZoomLength / data1.length * 100
          })
      }

      var option = {
        title: {
          text: '空压机KPI对比',
          textStyle: {
            color: '#fff',
            fontSize: 24
          },
          left: 'center'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          },
          // formatter: function(params) {
          //   var str = '';
          //   str += params[0].name;
          //   str += '<br/>' + that.equipDesc[params[0].dataIndex]
          //   str += '<br/>'
          //   var now = new Date();
          //   for (var i = 0; i < params.length; i++) {
          //     str += '<br/>' + params[i].seriesName + ':' + params[i].value;
          //   }
          //   return str;
          // }
        },
        legend: {
          data: ['kpi', '公斤单耗', '模单耗'],
          x: 'right',
          textStyle: {
            color: '#fff',
            fontSize: 16
          }
        },
        grid: {
          left: '6%',
          bottom: 50,
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: this.dataset[0],
            axisTick: {
              alignWithLabel: true,
              interval: 0
            },
            axisLabel: {
              interval: 0,
              color: '#fff',
              fontSize: 12
            },
            axisLine: {
              // 轴线
              lineStyle: {
                color: '#7f8fa4'
              }
            }
          }
        ],
        yAxis: [
          {
            name: '',
            type: 'value',
            nameTextStyle: {
              color: '#fff',
              fontSize: 16
            },
            boundaryGap: [0, '10%'],
            axisLabel: {
              color: '#fff',
              fontSize: 16
            },
            splitLine: {
              show: false
            },
            axisLine: {
              lineStyle: {
                color: '#7f8fa4'
              }
            }
          }
        ],
        dataZoom: zoomConfig,
        series: [
          {
            name: 'kpi',
            type: 'bar',
            data: this.dataset[1],
            color: serColors[0],
            xAxisIndex: 0,
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  position: 'top',
                  textStyle: {
                    color: '#fff',
                    fontSize: 14
                  }
                }
              }
            }
          },
        ]
      };
      // 5：展示数据
      myChart.setOption(option);
    }
  }
};
</script>

<style lang="less" scoped >
#kpi1 {
  position: relative;
  width: 70%;
  height: 95%;
  box-sizing: border-box;
  .box {
    position: relative;
    width: 100%;
    height: 100%;
  }
}
</style>
